import type { MeResponse, MeResponseFI, MeResponseSE } from '@/api/me/types';

export const isMeResponseSE = (response: MeResponse): response is MeResponseSE => response.country === 'SE';

export const isMeResponseFI = (response: MeResponse): response is MeResponseFI => response.country === 'FI';
